var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-count"},[_c('ul',{staticClass:"number-list"},_vm._l((_vm.numberList),function(item,index){return _c('li',{key:index,staticClass:"item",style:(_vm.getItemStyle(+item, index === _vm.numberList.length - 1))},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }